import { Select } from "@mantine/core";
import { Pencil } from "lucide-react";
import { useMemo } from "react";
import MultiSelectDropdown from "../../../../../shared/ui/dropdown/MultiSelectDropdown";

type Props = {
  users: number,
  metric: any,
  setMetric: any,
  showHidden: boolean,
  setShowHidden: any,
  filteredTraits: any[],
  filteredMetrics: any[],
  selectedColumns: any[],
  setSelectedColumns: any,
};

const lastSeenOptions = [
  { value: "Last day", label: "Last day" },
  { value: "Last 7 days", label: "Last 7 days" },
  { value: "Last 30 days", label: "Last 30 days" },
  { value: "Last 90 days", label: "Last 90 days" },
  { value: "Last 180 days", label: "Last 180 days" },
  { value: "Last 365 days", label: "Last 365 days" },
];

const UsersToolbar = ({
  users,
  showHidden, setShowHidden, filteredTraits, filteredMetrics, selectedColumns, setSelectedColumns,
  metric, setMetric,
}: Props) => {
  const selectedValue = useMemo(() => {
    if (!metric?.name || metric.id === -1) return null;
    return metric.name;
  }, [metric]);

  return (
    <div className="flex mt-2 gap-10 px-5 w-full justify-between items-center">
      <h2 className="text-gray-900 whitespace-nowrap text-[20px] font-semibold">
        {users}
        {" "}
        users
      </h2>
      <div className="flex flex-wrap gap-2 items-center justify-end flex-1">
        <Select
          value={selectedValue}
          onChange={(value) => {
            if (value) {
              const idx = lastSeenOptions.findIndex((o) => o.value === value);
              setMetric({ id: idx + 1, name: value });
            }
          }}
          data={lastSeenOptions}
          placeholder="Last Seen"
          size="xs"
          classNames={{
            input: "h-8 text-xs rounded-md border-gray-200",
            root: "w-[150px]",
          }}
        />
        <MultiSelectDropdown
          selected={selectedColumns}
          setSelected={setSelectedColumns}
          isOpen={showHidden}
          setIsOpen={setShowHidden}
          list={filteredTraits}
          metricsList={filteredMetrics}
          type="User"
        >
          <button
            type="button"
            onClick={() => { setShowHidden((state: any) => !state); }}
            className="inline-flex items-center gap-1.5 h-8 px-3 text-xs font-medium border border-gray-200 rounded-md bg-white text-gray-700 hover:bg-gray-50 transition-colors"
          >
            <Pencil className="h-3.5 w-3.5" />
            Edit columns
          </button>
        </MultiSelectDropdown>
      </div>
    </div>
  );
};

export default UsersToolbar;
